<template>
    <div class="crop-box">
        <img
            :src="images"
            :alt="alt"
            class="crop-img"
        >
    </div>
</template>

<script setup>
defineProps({
    images: { type: String, required: true },
    alt:    { type: String, required: true }
})
</script>

<style scoped>
.crop-box {
    aspect-ratio: 4 / 2;
    width: 100%;
    background: #000;
    border-radius: .5rem;
    overflow: hidden;
}

.crop-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}
</style>
